import { useDebounce } from '@uidotdev/usehooks'
import { useState } from 'react'
export interface PaginationProps {
  currentPage: number
  setCurrentPage: (page: number) => void
  perPage: number
  setPerPage: (perPage: number) => void
  search: string
  setSearch: (search: string) => void
  onRefresh: () => void
  totalRecords: number
}

function useAceTable() {
  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage, setPerPage] = useState(10)
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search, 500)

  function onSearchChange(value: string) {
    setSearch(value)
    setCurrentPage(1)
  }

  function onPerPageChange(newPerPage: number) {
    setCurrentPage(1)
    setPerPage(newPerPage)
  }

  function onPageChange(page: number) {
    setCurrentPage(page)
  }

  return {
    currentPage,
    recordsPerPage,
    onPerPageChange,
    onSearchChange,
    onPageChange,
    debouncedSearch,
    search,
    setCurrentPage,
  }
}

export { useAceTable }
